import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getRequestList,updateRequestStatus,getFilters} from "services/redux/contractRenewal/action";
import RenewalRequestList from "./renewalRequestList";

const mapStateToProps = (state) => ({
  requestList: state.contractRenewalReducer.requestList,
  requestStatus: state.contractRenewalReducer.requestStatus,
  filters: state.contractRenewalReducer.filters,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getRequestList,
      updateRequestStatus,
      getFilters
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(RenewalRequestList);
